import React, { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './rum'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import { getAppSecurity } from '@lib/okta-web'
import { ApiAxiosProvider } from '@lib/rest-web'

import '@lib/theme/css/bootstrap-theme'

import { TitleProvider } from '@lib/web'

import App from './app/app'

import './assets/fonts/fonts.css'

import { environment } from './environment'

import './main.css'

import {
  FullscreenSpinner,
  FullscreenSpinnerProvider,
} from './primitives/FullscreenSpinner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      staleTime: 100,
    },
  },
})

const { AppSecurity } = getAppSecurity(environment.auth)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <TitleProvider prefix="Inventory" separator=": ">
      <FullscreenSpinnerProvider>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AppSecurity>
              <QueryClientProvider client={queryClient}>
                <ApiAxiosProvider config={environment.api}>
                  <App />

                  <FullscreenSpinner />

                  {environment.production === false && (
                    <ReactQueryDevtools initialIsOpen={false} />
                  )}
                </ApiAxiosProvider>
              </QueryClientProvider>
            </AppSecurity>
          </QueryParamProvider>
        </BrowserRouter>
      </FullscreenSpinnerProvider>
    </TitleProvider>
  </StrictMode>
)
